<!--
  ~ /**
  ~   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
  ~   ~  * No part of this publication may be reproduced, distributed,
  ~   ~  * or transmitted in any form or by any means, including photocopying, recording,
  ~   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
  ~   ~  * except in the case of brief quotations embodied in critical
  ~   ~  * reviews and certain other noncommercial uses permitted by copyright law.
  ~   ~  * AUTHOR : bs
  ~   ~  * DATE : 29/04/2025 17:28
  ~ **/
  -->

<inf-sliding-menu
  #botSliding
  [withBackground]="true"
  [canCloseOnBackgroundClick]="false"
  [withMarge]="false"
>
  <div class="chat-container">
    <div class="chat-header">
      <div class="title">Integrix® Assistant</div>
      <div class="actions">
        @for(action of actions; track action.name) {
        <div class="action" (click)="onActionClick(action.name)">
          <i class="fa-light fa-{{action.icon}}"></i>
        </div>
        }
      </div>
    </div>
    <div #chatContent class="chat-content">
      @for (message of messages; track message.id) { @switch (message.sender) {
      @case ('user') {
      <div class="user-message-container">
        <div class="user-message">{{ message.content }}</div>
      </div>
      } @case ('bot') {
      <div class="bot-message-container">
        <div class="bot-message">{{ message.content }}</div>
      </div>
      } @case ('action') {
      <div class="action-message-container">
        <div class="action-message" (click)="selectAction(message)">
          <span class="right-arrow"><i class="fa-light fa-right"></i></span> {{
          message.content }}
        </div>
      </div>
      } @case ('response') {
      <div class="bot-message-container">
        <div class="bot-message">{{ message.content }}</div>
      </div>
      } } }
    </div>
    <div class="chat-footer">
      <div class="footer-content" [ngClass]="{'focus': isFooterFocus}">
        <input
          class="footer-input"
          [(ngModel)]="newMessage"
          [placeholder]="'Poser une question...'"
          (click)="onFocus()"
          (blur)="onFocus()"
        />
        <i class="fa-light fa-paper-plane" (click)="sendMessage()"></i>
      </div>
    </div>
  </div>
</inf-sliding-menu>
